var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',_vm._g(_vm._b({staticClass:"ma-auto",class:{ 'fill-space': _vm.absolute },attrs:{"size":_vm.loaderSize,"width":_vm.loaderSize / 10,"color":_vm.color,"indeterminate":""}},'v-progress-circular',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }